import { render, staticRenderFns } from "./addNewDialog.vue?vue&type=template&id=5332c07a&"
import script from "./addNewDialog.vue?vue&type=script&lang=js&"
export * from "./addNewDialog.vue?vue&type=script&lang=js&"
import style0 from "./addNewDialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports